import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import {
    Card,
    CardBody,
    Container,
    Spinner
} from "reactstrap";

import ChatService from "../service/ChatService";
import ChatHubService from "../service/ChatHubService";

import { ChatMessage } from "../types/ChatMessage";

import ChatHeader from "../Components/ChatHeader";
import MessageInput from "../Components/MessageInput";
import MessageList from "../Components/MessageList";
import AuthHelper from "../../../../common/auth/service/AuthHelper";
interface Props{
    groupId:string;
}

const GroupChatPage = ({
    groupId
}:Props) => {

    const [loading, setLoading] =
        useState(true);
    const [replyMessage, setReplyMessage] =
        useState<ChatMessage | null>(null);
    const [messages, setMessages] =
        useState<ChatMessage[]>([]);
    const [reactionRefresh, setReactionRefresh] =
        useState(0);
    const [typingUser, setTypingUser] =
        useState("");

    useEffect(() => {

        if (!groupId)
            return;

        connect();

        return () => {

            disconnect();

        };

    }, [groupId]);

    const connect = async () => {

        if (!groupId)
            return;

        const token =
            AuthHelper.getToken();

        if (!token)
            return;

        await loadMessages();

        await ChatHubService.start(token);

        await ChatHubService.joinGroup(groupId);

       ChatHubService.onReceiveMessage((message: ChatMessage) => {

    console.log("SignalR ReceiveMessage:", message);

    setMessages(previous => {

        const exists = previous.some(
            x => x.chatMessageId === message.chatMessageId
        );

        if (exists)
            return previous;

        return [...previous, message];
    });

});
        ChatHubService.onMessageEdited(

            (
                messageId: string,
                message: string
            ) => {

                setMessages(previous =>

                    previous.map(item =>

                        item.chatMessageId === messageId

                            ? {

                                ...item,

                                message,

                                isEdited: true

                            }

                            : item

                    )

                );

            });

        ChatHubService.onMessageDeleted(

            (messageId: string) => {

                setMessages(previous =>

                    previous.filter(

                        item =>

                            item.chatMessageId !== messageId

                    )

                );

            });

        ChatHubService.onUserTyping(

            (userName: string) => {

                setTypingUser(userName);

            });

        ChatHubService.onUserStopTyping(

            () => {

                setTypingUser("");

            });
        ChatHubService.onReactionUpdated(

            () => {

                setReactionRefresh(
                    value => value + 1
                );

            }

        );

    };

    const disconnect = async () => {

        if (!groupId)
            return;

        await ChatHubService.leaveGroup(groupId);

        await ChatHubService.stop();

    };

    const loadMessages = async () => {

        if (!groupId)
            return;

        setLoading(true);

        try {

            const response =
                await ChatService.getMessages(groupId);

            setMessages(response);

        }
        catch (error) {

            console.error(error);

        }
        finally {

            setLoading(false);

        }

    };

    const sendMessage = async (message: string) => {

        if (!groupId)
            return;

        await ChatHubService.sendMessage({

            groupId,

            message,

            messageType: 0,

            replyToMessageId: replyMessage?.chatMessageId

        });

        setReplyMessage(null);

    };

    const editMessage = async (
        messageId: string,
        message: string
    ) => {

        await ChatHubService.editMessage(
            messageId,
            message
        );

    };

    const deleteMessage = async (
        messageId: string
    ) => {

        if (!window.confirm("Delete this message?"))
            return;

        await ChatHubService.deleteMessage(
            messageId
        );

    };


    if (loading)
        return (

            <Container className="text-center mt-5">

                <Spinner />

            </Container>

        );

    return (

        <Container
            fluid
            className="py-3"
        >

            <Card className="" style={{backgroundColor:'#d1e7dd',border:'none'}}>

                <CardBody className="p-0">

                    {/* <ChatHeader /> */}

                    <MessageList
                        messages={messages}
                        reactionRefresh={reactionRefresh}
                        onReply={setReplyMessage}
                        onEdit={editMessage}
                        onDelete={deleteMessage}
                    />

                    {typingUser && (

                        <div className="px-3 pb-2 text-muted">

                            {typingUser} is typing...

                        </div>

                    )}

                    <MessageInput
                        onSend={sendMessage}
                        replyToMessage={replyMessage?.message}
                        replyToUser={replyMessage?.senderName}
                        onCancelReply={() => setReplyMessage(null)}
                    />

                </CardBody>

            </Card>

        </Container>

    );

};

export default GroupChatPage;